import { useEffect, useState } from 'react';

// graphql
import { PageInfo, useCashierCashTransfersQuery, useCashierCashWithdrawalsQuery } from '@/generated/graphql';

// material ui
import { Grid } from '@mui/material';

// interfaces
import {
  ICashierCashWithdrawalQueryVariable,
  ICashierCashWithdrawalTable,
  mapGQLCashierCashWithdrawal,
  ICashierCashTransferTable,
  ICashierCashTransferQueryVariable,
  mapGQLCashierCashTransfer,
} from '@/shared/interfaces';

interface IProps {
  refetchCashierCashQuery: boolean;
  setRefetchCashierCashQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

// components
import { TableCashierCashWithdrawals } from './cashier-cash-withdrawal-table';
import { TableCashierCashTransfers } from './cashier-cash-transfer-table';

export const CashierCash = ({ refetchCashierCashQuery, setRefetchCashierCashQuery }: IProps) => {
  const [cashierCashWithdrawals, setCashierCashWithdrawals] = useState<ICashierCashWithdrawalTable[]>([]);
  const [cashierCashTransfers, setCashierCashTransfers] = useState<ICashierCashTransferTable[]>([]);

  const [cashierCashWithdrawalsQueryVariable, setCashierCashWithdrawalsQueryVariable] = useState<ICashierCashWithdrawalQueryVariable>({
    first: 25,
  });

  const [cashierCashTransfersQueryVariable, setCashierCashTransfersQueryVariable] = useState<ICashierCashTransferQueryVariable>({
    first: 25,
  });

  const [cashierCashWithdrawalsPageInfo, setCashierCashWithdrawalsPageInfo] = useState<PageInfo>();
  const [cashierCashWithdrawalsTotalCount, setCashierCashWithdrawalsTotalCount] = useState<number>(0);
  const [cashierCashTransfersPageInfo, setCashierCashTransfersPageInfo] = useState<PageInfo>();
  const [cashierCashTransfersTotalCount, setCashierCashTransfersTotalCount] = useState<number>(0);

  const cashierCashWithdrawalsQuery = useCashierCashWithdrawalsQuery({
    variables: cashierCashWithdrawalsQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      console.log('🚀 ~ onCompleted1 ~ data:', data);
      const mappedData = data.cashierCashWithdrawals.nodes.map((x) => mapGQLCashierCashWithdrawal(x));

      const mappedTableData: ICashierCashWithdrawalTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setCashierCashWithdrawals(mappedTableData);
        setCashierCashWithdrawalsPageInfo(data.cashierCashWithdrawals.pageInfo);
        setCashierCashWithdrawalsTotalCount(data.cashierCashWithdrawals.totalCount);
      }, 100);
    },
  });

  const cashierCashTransfersQuery = useCashierCashTransfersQuery({
    variables: cashierCashTransfersQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      console.log('🚀 ~ onCompleted2 ~ data:', data);
      const mappedData = data.cashierCashTransfers.nodes.map((x) => mapGQLCashierCashTransfer(x));

      const mappedTableData: ICashierCashTransferTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setCashierCashTransfers(mappedTableData);
        setCashierCashTransfersPageInfo(data.cashierCashTransfers.pageInfo);
        setCashierCashTransfersTotalCount(data.cashierCashTransfers.totalCount);
      }, 100);
    },
  });

  useEffect(() => {
    if (refetchCashierCashQuery === true) {
      console.log('REFETCH');
      setRefetchCashierCashQuery(false);
      cashierCashWithdrawalsQuery.refetch({
        ...cashierCashWithdrawalsQueryVariable,
      });
      cashierCashTransfersQuery.refetch({
        ...cashierCashTransfersQueryVariable,
      });
    }
  }, [refetchCashierCashQuery]);

  return (
    <>
      <Grid container spacing={2} px={2}>
        <Grid size={6}>
          <TableCashierCashTransfers
            rows={cashierCashTransfers}
            setCashierCashTransferQueryVariable={setCashierCashTransfersQueryVariable}
            cashierCashTransferQueryVariable={cashierCashTransfersQueryVariable}
            totalCount={cashierCashTransfersTotalCount}
            pageInfo={cashierCashTransfersPageInfo}
            getCashierCashTransferLoading={cashierCashTransfersQuery.loading}
          />
        </Grid>
        <Grid size={6}>
          <TableCashierCashWithdrawals
            rows={cashierCashWithdrawals}
            setCashierCashWithdrawalQueryVariable={setCashierCashWithdrawalsQueryVariable}
            cashierCashWithdrawalQueryVariable={cashierCashWithdrawalsQueryVariable}
            totalCount={cashierCashWithdrawalsTotalCount}
            pageInfo={cashierCashWithdrawalsPageInfo}
            getCashierCashWithdrawalLoading={false}
          />
        </Grid>
      </Grid>
    </>
  );
};
